import { StyleSheet } from 'react-native';

import { THEME } from '../../reactor/common';

const { UNIT } = THEME;

export default StyleSheet.create({
  tile: {
    margin: UNIT / 2,
  },
});
